import { needsMessage, useCan } from "modules/settings/accessRoles";
import {
  Avatar,
  Box,
  Button as MuiButton,
  Card,
  CardContent,
  Divider as MuiDivider,
  LinearProgress as MuiLinearProgress,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Chip,
  Stack
} from "@mui/material";

import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { makeStyles } from "@mui/styles";
import { withStyles } from "@mui/styles";
import TableContainer from "@mui/material/TableContainer";
import ChatIcon from "@mui/icons-material/Chat";
import MailIcon from "@mui/icons-material/Mail";
import PermScanWifiIcon from "@mui/icons-material/PermScanWifi";
import SettingsIcon from "@mui/icons-material/Settings";
import Skeleton from "@mui/material/Skeleton";
import { spacing } from "@mui/system";
// Redux Components
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import styled from "styled-components";
import { updateUserPasswordEmailNotifier, updateUserEmail , sendTemporaryPassword} from "../../../modules/userProfiles/api/actions";
import { dateFormatter, formatPhoneNumber } from "../../../setup/helpers";
// snackbar
import { setSnackbar } from "../../snackbar/api/snackbar";
import axios from "axios"

const LinearProgress = MuiLinearProgress;
const Divider = styled(MuiDivider)(spacing);
const Button = styled(MuiButton)(spacing);

const StyledMenu = withStyles({
  paper: {
    border: "1px solid #d3d4d5",
  },
})((props) => (
  <Menu
    elevation={0}
    getContentAnchorEl={null}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "center",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "center",
    }}
    {...props}
  />
));

const StyledNavMenuItem = withStyles((theme) => ({
  root: {
    "&:focus": {
      backgroundColor: theme.palette.primary.main,
      "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
        color: theme.palette.common.white,
      },
    },
  },
}))(MenuItem);


const AccountUserDetailsCard = (props) => {
  const canManagePortalUsers = useCan()("portalUsers");
  if(props.UserProfile) {
    props.userProfiles.selectedUserProfile = props.UserProfile 
  }
  const useStyles = makeStyles((theme) => ({
    title: {
      flexGrow: 1,
    },
    percentDif: {
      textAlign: "right",
      color: "green",
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
    loadingIcon: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
    },
    StatsIcon: {
      width: "32px",
      height: "32px",
      color: theme.palette.secondary.main,
      position: "absolute",
      right: "16px",
      top: "32px",
    },
    rightSideHeader: {
      display: "flex",
      alignItems: "flex-end",
      flexDirection: "row",
      justifyContent: "flex-end",
    },
    rightSideHeaderSubMenuToolBar: {
      display: "flex",
      alignItems: "flex-end",
      flexDirection: "row",
      justifyContent: "flex-end",
      margin: "0px",
      padding: "0px",
    },
    SubMenuToolBarIcon: {
      width: "25px",
      height: "25px",
      margin: "2px",
      paddingBotom: "5px",
    },
    orange: {
      //color: theme.palette.getContrastText(deepOrange[500]),
    },
    UserBoxText: {
      textAlign: "center",
    },
    UserProfileDetailsButton: {
      padding: "5px",
    },
    AvatarText: {
      marginTop: "20%",
      height: "128px",
      width: "128px",
      textAlign: "center",
      alignSelf: "center",
    },
    AvatarIcon: {
      display: "inline-block",
      height: "128px",
      width: "128px",
      backgroundColor: "gray",
      borderColor: theme.palette.primary.main,
      borderStyle: "solid",
    },
    modernAvatar: {
      width: 80,
      height: 80,
      fontSize: "2rem",
      fontWeight: "bold",
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      border: `3px solid ${theme.palette.background.paper}`,
      boxShadow: theme.shadows[3],
    },
    userInfoCard: {
      padding: theme.spacing(3),
      borderRadius: theme.spacing(2),
      background: `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.secondary.main}15 100%)`,
      border: `1px solid ${theme.palette.divider}`,
    },
    userNameSection: {
      marginLeft: theme.spacing(2),
    },
    roleChip: {
      marginTop: theme.spacing(1),
      fontWeight: "bold",
    },
    infoGrid: {
      marginTop: theme.spacing(2),
    },
    infoItem: {
      padding: theme.spacing(2),
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.spacing(1),
      border: `1px solid ${theme.palette.divider}`,
      height: "100%",
    },
    infoLabel: {
      color: theme.palette.text.secondary,
      fontSize: "0.875rem",
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
    },
    infoValue: {
      color: theme.palette.text.primary,
      fontSize: "1rem",
      fontWeight: 500,
      wordBreak: "break-word",
    },
    ChartWrapper: {
      height: "200px",
      maxHeight: "200px",
      minHeight: "200px",
    },
    AccountInfoGrid: {
      height: "400px",
      maxHeight: "400px",
      minHeight: "400px",
    },
  }));

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [emailDialogOpen, setEmailDialogOpen] = React.useState(false);
  const [tempPasswordDialogOpen, setTempPasswordDialogOpen] = React.useState(false);
  const [tempPassword, setTempPassword] = React.useState("");
  const [newUserEmail, setNewUserEmail] = React.useState(null);

  const dispatch = useDispatch();

  const handleUserProfileEditingDropDownClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    console.log("Settings button clicked", event.currentTarget);
    setAnchorEl(event.currentTarget);
    console.log("anchorEl set to:", event.currentTarget);
  };
  const setUserEmail = (event) =>
 {
    setNewUserEmail(event.currentTarget.value);
 }
  const handleSendPasswordResetUpdate = () => {
    if (props.userProfiles.selectedUserProfile && props.userProfiles.selectedUserProfile != null) {
      dispatch(setSnackbar(true, "warning", "Sending Password Reset Email"));
      props.updateUserPasswordEmailNotifier(props.userProfiles.selectedUserProfile.email).then(() => {
        dispatch(setSnackbar(true, "success", "Password Reset Email Sent"));
      });
    }
  };
  const handleUpdateAccountEmail = () => {
    if (props.userProfiles.selectedUserProfile && props.userProfiles.selectedUserProfile!= null) {
      dispatch(setSnackbar(true, "warning", "Updating Account Email"));
    

        let updateEmailPayload = {

          email:newUserEmail,
          uuid: props.userProfiles.selectedUserProfile.uuid
        
      }

      props.updateUserEmail(updateEmailPayload).then(() => {
        setEmailDialogOpen(false);
        if(!props.userProfiles.error){
          props.userProfiles.selectedUserProfile.email = updateEmailPayload.email;
        }
      })
    }
    else{
      dispatch(setSnackbar(true, "error", "No user profile"))
    }

  }
  const generateRandomPassword = () => {

    let array = new Uint32Array(6);

    window.crypto.getRandomValues(array);
    let tempPass = "APL_"+Array.from(array, dec => ('0' + dec.toString(16)).substr(-2)).join('');

    return tempPass.substring(0, 9);
}   
  const handleDialogOpen = () => {
    setEmailDialogOpen(true);
  }
  const handleDialogClose = () => {
    setEmailDialogOpen(false);
  }

  const handleSendTemporaryPass = () => {
    if (props.userProfiles.selectedUserProfile) {
      dispatch(setSnackbar(true, "warning", "Updating Account Email"));
    

        let sendTempPassPayload = {

          password:tempPassword,
          uuid: props.userProfiles.selectedUserProfile.uuid
        
      }
      props.sendTemporaryPassword(sendTempPassPayload).then(setTempPasswordDialogOpen(false));
  }

    else{
      dispatch(setSnackbar(true, "error", "No user profile"))
    }
}


  const handleTempPasswordDialogOpen = () => {
    let tempPassword = generateRandomPassword();

    setTempPassword(tempPassword);
    setTempPasswordDialogOpen(true);


  }
  const handleTempPasswordDialogClose = () => {
    setTempPasswordDialogOpen(false);
  }

  const handleSendAccountInvitation = () => {
    //Must check if it is a PM
    dispatch(setSnackbar(true, "warning", "Sending Account Invtiation Email"));
    if(props.isPm == true){
      axios.post("accountcreation/invitation/pm", {
        pm: {
          uuid: props.propertyManagers.data.propertyManager.uuid,
          name: props.propertyManagers.data.propertyManager.name,
          email: props.propertyManagers.data.propertyManager.email
        }
      }).then(response => {
        if (response.status == 200) {
          dispatch(setSnackbar(true, "success", "Invitation sent."));
        }
        else
          throw Error;
      }).catch(error => {
        dispatch(setSnackbar(true, "error", "Invitation unable to send."));
  
      })
    }else {
      
      axios.post("accountcreation/invitation", {
        accountUuid: props.account.data.account.uuid,
        accountNum: props.account.data.account.accountNum,
        name: `${props.account.data.account.firstName} ${props.account.data.account.lastName}`,
        email: props.account.data.account.email,
      }).then(response => {
        if (response.status == 200) {
          dispatch(setSnackbar(true, "success", "Invitation sent."));
        }
        else
          throw Error;
      }).catch(error => {
        dispatch(setSnackbar(true, "error", "Invitation unable to send."));
  
      })
    }


  };
  const handleUserProfileEditingDropDownClose = () => {
    console.log("Settings menu closing");
    setAnchorEl(null);
  };

  // Helper function to get user role information
  const getUserRole = () => {
    if (!props.userProfiles.selectedUserProfile) return null;
    
    const user = props.userProfiles.selectedUserProfile;
    if (user.isSuperUser == 1) return { label: "Admin", color: "error" };
    if (user.isInternalUser == 1) return { label: "APL Employee", color: "warning" };
    if (user.isCustomer == 1) return { label: "Customer", color: "primary" };
    return { label: "User", color: "default" };
  };

  // Debug logging
  console.log("Render - anchorEl:", anchorEl, "Menu should be open:", Boolean(anchorEl));

  return (
    <Card mb={6}>
      <CardContent xs={12} sm={12} md={12} lg={12}>
      <Dialog open={emailDialogOpen} onClose={handleDialogClose}>
        <DialogTitle>Update Email</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please enter the new email address
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="userEmail"
            label="Email Address"
            type="email"
            fullWidth
            variant="standard"
            onChange={setUserEmail}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button onClick={handleUpdateAccountEmail}>Submit</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={tempPasswordDialogOpen} onClose={handleTempPasswordDialogClose}>
        <DialogTitle>Send Temporary Password</DialogTitle>
        <DialogContent>
          <DialogContentText style={{color: 'black'}}>Temporary Password: {tempPassword}</DialogContentText>
          <br />
          <DialogContentText style={{color: 'black'}}>Do you want to set this as the temporary password for this account?</DialogContentText>
          <DialogContentText style={{color: 'red'}}>*** This cannot be undone ***</DialogContentText>
        
        </DialogContent>
        <DialogActions>
          <Button onClick={handleTempPasswordDialogClose}>Cancel</Button>
          <Button onClick={handleSendTemporaryPass}>Submit</Button>
        </DialogActions>
      </Dialog>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 100%', md: '1 1 100%', lg: '1 1 100%' } }}>
            <Typography variant="h6" gutterBottom>
              User Profile Details
            </Typography>
          </Box>
          <Box
            className={classes.rightSideHeaderSubMenuToolBar}
            sx={{ flex: '0 0 auto' }}
          >
            <Button
              onClick={handleUserProfileEditingDropDownClick}
              aria-controls="userProfiles-act-settings"
              aria-haspopup="true"
              variant="text"
              color="inherit"
              sx={{ minWidth: 'auto', p: 1 }}
            >
              <SettingsIcon
                fontSize="medium"
                className={classes.SubMenuToolBarIcon}
              />
            </Button>

            <StyledMenu
              id="userProfiles-act-settings"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleUserProfileEditingDropDownClose}
            >
                {/*List Item*/}
                {props.userProfiles.selectedUserProfile || props.UserProfile ? (<>
                  <StyledNavMenuItem>
                    <ListItemIcon>
                      <ChatIcon fontSize="small" />
                    </ListItemIcon>
                    <Link
                      href={`mailto:${props.userProfiles.selectedUserProfile?.email}`}
                      onClick={() => {
                        navigator.clipboard.writeText(props.userProfiles.selectedUserProfile?.email);
                        dispatch(
                          setSnackbar(
                            true,
                            "success",
                            "Copied email to clipboard."
                          )
                        );
                      }}
                    >
                      <ListItemText primary="Send Email"></ListItemText>
                    </Link>
                  </StyledNavMenuItem>
                  <StyledNavMenuItem onClick={handleDialogOpen} disabled={!canManagePortalUsers} title={canManagePortalUsers ? undefined : needsMessage("portalUsers")}>
                    <ListItemIcon>
                      <MailIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Update Account Email" />
                  </StyledNavMenuItem>
                  <StyledNavMenuItem onClick={handleSendPasswordResetUpdate}>
                    <ListItemIcon>
                      <PermScanWifiIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Reset Password" />
                  </StyledNavMenuItem> 
                  <StyledNavMenuItem onClick={handleTempPasswordDialogOpen} disabled={!canManagePortalUsers} title={canManagePortalUsers ? undefined : needsMessage("portalUsers")}>
                    <ListItemIcon>
                      <PermScanWifiIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Send Temporary Password" />
                  </StyledNavMenuItem> 
                  
                  </>
                ) : (
                  <StyledNavMenuItem onClick={handleSendAccountInvitation}>
                    <ListItemIcon>
                      <PermScanWifiIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Resend Account Invitation" />
                  </StyledNavMenuItem>
                )}
              </StyledMenu>
          </Box>
        </Box>
        <Divider className="mb-2 mt-2" my={1} />
        {props.userProfiles.isLoading || props.isLoading ? (
          <Box className={classes.userInfoCard}>
            {/* Header Section Skeleton */}
            <Box display="flex" alignItems="center" mb={3}>
              <Skeleton
                variant="circular"
                width={80}
                height={80}
                sx={{ 
                  bgcolor: 'action.hover',
                  flexShrink: 0
                }}
              />
              <Box className={classes.userNameSection} flex={1}>
                <Skeleton
                  variant="text"
                  width="60%"
                  height={40}
                  sx={{ bgcolor: 'action.hover', mb: 1 }}
                />
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={24}
                  sx={{ bgcolor: 'action.hover', borderRadius: 1 }}
                />
              </Box>
            </Box>

            {/* Info Grid Skeleton */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }} className={classes.infoGrid}>
              {[...Array(4)].map((_, index) => (
                <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }} key={index}>
                  <Box className={classes.infoItem}>
                    <Skeleton
                      variant="text"
                      width="40%"
                      height={20}
                      sx={{ bgcolor: 'action.hover', mb: 0.5 }}
                    />
                    <Skeleton
                      variant="text"
                      width="80%"
                      height={24}
                      sx={{ bgcolor: 'action.hover' }}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        ) : props.userProfiles.selectedUserProfile && props.userProfiles.selectedUserProfile != null ? (
          <Box className={classes.userInfoCard}>
            {/* Header Section with Avatar and Name */}
            <Box display="flex" alignItems="center" mb={3}>
              <Avatar className={classes.modernAvatar}>
                {props.userProfiles.selectedUserProfile
                  ? `${props.userProfiles.selectedUserProfile.firstName[0]}${props.userProfiles.selectedUserProfile.lastName[0]}`
                  : "?"}
              </Avatar>
              <Box className={classes.userNameSection} flex={1}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                  {props.userProfiles.selectedUserProfile
                    ? `${props.userProfiles.selectedUserProfile.firstName} ${props.userProfiles.selectedUserProfile.lastName}`
                    : "APL User"}
                </Typography>
                {getUserRole() && (
                  <Chip
                    label={getUserRole().label}
                    color={getUserRole().color}
                    size="small"
                    className={classes.roleChip}
                  />
                )}
              </Box>
            </Box>

            {/* Contact Information Grid */}
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }} className={classes.infoGrid}>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                <Box className={classes.infoItem}>
                  <Typography className={classes.infoLabel}>
                    Email Address
                  </Typography>
                  <Typography className={classes.infoValue}>
                    {props.userProfiles.selectedUserProfile?.email || "N/A"}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                <Box className={classes.infoItem}>
                  <Typography className={classes.infoLabel}>
                    Phone Number
                  </Typography>
                  <Typography className={classes.infoValue}>
                    {props.userProfiles.selectedUserProfile?.phone 
                      ? formatPhoneNumber(props.userProfiles.selectedUserProfile.phone) 
                      : "N/A"}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                <Box className={classes.infoItem}>
                  <Typography className={classes.infoLabel}>
                    User ID
                  </Typography>
                  <Typography className={classes.infoValue}>
                    {props.userProfiles.selectedUserProfile?.uuid?.substring(0, 8) || "N/A"}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ flex: { xs: '1 1 100%', sm: '1 1 calc(50% - 8px)' } }}>
                <Box className={classes.infoItem}>
                  <Typography className={classes.infoLabel}>
                    Account Status
                  </Typography>
                  <Typography className={classes.infoValue}>
                    Active
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Box>
        ) : (
          <Box className={classes.userInfoCard}>
            <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" py={4}>
              <Avatar className={classes.modernAvatar} sx={{ mb: 2 }}>
                ?
              </Avatar>
              <Typography variant="h5" fontWeight="bold" gutterBottom>
                User Profile Not Found
              </Typography>
              <Typography variant="body1" color="text.secondary" textAlign="center">
                No associated user profile available for this account
              </Typography>
            </Box>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

// Component Properties
AccountUserDetailsCard.propTypes = {
  // Store objects:
  account: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  userProfiles: PropTypes.object.isRequired,
  updateUserPasswordEmailNotifier: PropTypes.func.isRequired,
  updateUserEmail: PropTypes.func.isRequired,
  sendTemporaryPassword: PropTypes.func.isRequired,
};

// Component State
function AccountUserDetailsCardState(state) {
  return {
    account: state.account,
    apl: state.apl,
    userProfiles: state.userProfiles,
    propertyManagers: state.propertyManagers
  };
}
export default connect(AccountUserDetailsCardState, {
  updateUserPasswordEmailNotifier,
  updateUserEmail,
  sendTemporaryPassword
})(AccountUserDetailsCard);
